import { useRef, useState } from "react";

export interface HistoryAction {
  type: string;
  undo(): void;
  redo(): void;
}

export function useHistory() {
  const undoStack = useRef<HistoryAction[]>([]);
  const redoStack = useRef<HistoryAction[]>([]);

  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);

  function syncUI() {
    setCanUndo(undoStack.current.length > 0);
    setCanRedo(redoStack.current.length > 0);
  }

  const api = {
    add(action: HistoryAction) {
      undoStack.current.push(action);
      redoStack.current.length = 0;
      syncUI();
    },

    undo() {
      const action = undoStack.current.pop();
      if (!action) return;
      action.undo();
      redoStack.current.push(action);
      syncUI();
    },

    redo() {
      const action = redoStack.current.pop();
      if (!action) return;
      action.redo();
      undoStack.current.push(action);
      syncUI();
    },

    clear() {
      undoStack.current.length = 0;
      redoStack.current.length = 0;
      syncUI();
    },

    get canUndo() {
      return undoStack.current.length > 0;
    },

    get canRedo() {
      return redoStack.current.length > 0;
    }
  };

  return api;
}